import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search, Building2, Loader2 } from "lucide-react";
import { NeuInput, NeuCard } from "../../components/neu/Neu";
import { avatarCompanies } from "../../api/platform";
import { AvatarEmployeeList } from "./AvatarEmployeeList";
import { AvatarGlobalReset } from "./AvatarGlobalReset";

// مالك المنصة: بحث لحظي عن شركة (مقترحات أثناء الكتابة) ثم تصفير الأفاتار.
export const AvatarResetPanel = () => {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const [picked, setPicked] = useState(null);
  const timer = useRef(null);

  const load = async () => {
    setBusy(true);
    try { setRows(await avatarCompanies(q.trim())); } catch { /* تجاهل */ }
    finally { setBusy(false); }
  };

  useEffect(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(load, 250);
    return () => clearTimeout(timer.current);
    // eslint-disable-next-line
  }, [q]);

  return (
    <NeuCard className="grid gap-5 p-4 sm:p-6" data-testid="avatar-reset-panel">
      <div className="grid gap-1">
        <h2 className="text-lg font-black sm:text-base">{t("platform.avatarsPanel.title")}</h2>
        <p className="text-sm text-muted-foreground sm:text-xs">{t("platform.avatarsPanel.hint")}</p>
      </div>

      <div className="flex justify-end">
        <AvatarGlobalReset onDone={load} />
      </div>

      <div className="relative">
        <Search className="pointer-events-none absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <NeuInput value={q} placeholder={t("platform.avatarsPanel.searchCompany")}
          onChange={(e) => setQ(e.target.value)} className="ps-10 pe-10" data-testid="avatar-company-q" />
        {busy ? <Loader2 className="absolute end-3 top-1/2 h-4 w-4 -translate-y-1/2 animate-spin text-primary" /> : null}
      </div>

      <div className="grid gap-2">
        {rows.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground">{t("platform.avatarsPanel.noCompanies")}</p>
        ) : rows.map((c) => (
          <button key={c.id} type="button" onClick={() => setPicked(c)} data-testid={`avatar-company-${c.id}`}
            className={`flex items-center gap-3 rounded-2xl px-4 py-3 text-start transition-[box-shadow] ${picked?.id === c.id ? "text-primary shadow-neu-in" : "shadow-neu-sm"}`}>
            <Building2 className="h-5 w-5 shrink-0" />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-bold">{c.name}</span>
              <span className="block text-xs text-muted-foreground">
                {t("platform.avatarsPanel.employees", { n: c.employees })} · {t("platform.avatarsPanel.withAvatar", { n: c.with_avatar })}
              </span>
            </span>
          </button>
        ))}
      </div>

      {picked ? <AvatarEmployeeList company={picked} onChanged={load} /> : (
        <p className="text-center text-xs text-muted-foreground">{t("platform.avatarsPanel.pickCompany")}</p>
      )}
    </NeuCard>
  );
};
